// sticky-nav-bar.js
export class StickyNavBar extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
	this._hasWrapped = false;
  }

  connectedCallback() {
    // Compute offset from the CSS 'top' of the closest ancestor <section>
    const ancestorSection = this.closest('.shopify-section--sticky-nav-bar');
	let topOffset = 0;
	let sectionHeight = 0;
	if (ancestorSection) {
      // Get the CSS 'top' value
      const style = window.getComputedStyle(ancestorSection);
      const topVal = style.getPropertyValue('top');
      topOffset = parseInt(topVal, 10) || 0;
      // Add the element's height
      sectionHeight = ancestorSection.offsetHeight || 0;
    }

    // Combined offset: CSS top + section height
    this.offset = (topOffset + sectionHeight) * -1;

    // Collect all in-page links (<a href="#...">) within this element
    const allLinks = Array.from(this.querySelectorAll('a[href^="#"]'));
    this.links = [];
    this.sections = [];

    // Hide links without a matching section or with empty content
    allLinks.forEach(link => {
      const selector = link.getAttribute('href');
      const target = document.querySelector(selector);
      const hasContent = target && target.innerHTML.trim().length > 0;
      if (hasContent) {
        this.links.push(link);
        this.sections.push(target);
      } else {
        link.style.display = 'none';
      }
    });
	
	if (this.hasAttribute('wrap-sections') && ancestorSection && !this._hasWrapped) {
      this.sections.forEach(sec => {
          if (sec !== ancestorSection) {
            ancestorSection.appendChild(sec);
          }
      });
      
      this._hasWrapped = true;
    }
	
    // Bind scroll listener
    window.addEventListener('scroll', this._onScroll, { passive: true });

    // Initialize active state
    this._onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
  }

  _onScroll() {
    const scrollPos = window.scrollY;
    let activeIndex = this.sections.findIndex((sec, i) => {
      const top = sec.offsetTop + this.offset;
      const nextSec = this.sections[i + 1];
      const nextTop = nextSec ? nextSec.offsetTop + this.offset : Infinity;
      return scrollPos >= top && scrollPos < nextTop;
    });

    // If you haven’t scrolled past the first section yet, snap to 0
    if (activeIndex < 0) activeIndex = 0;

    // Toggle .active on each link
    this.links.forEach((link, i) => {
      link.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
    });
	
  }
}

// Define the custom element
customElements.define('sticky-nav-bar', StickyNavBar);
